kdx-pageselector {
  max-width: 50%;
  margin: 0 auto;
}
.kdx-pageselector {
  background: #FFFFFF;
  border-radius: 14px;
  opacity: 1;
  box-shadow: 0px 3px 6px #00000029;
  margin-top: -35px;
  z-index: 5;
  position: relative;


  &__inner {
      display: flex;
      align-items: center;
      padding: 25px 22px 22px 22px;

      .kdx-pageselector__title {
        color: $primary;
        @include text-size(16);
        @include line-height(24);
        font-weight: 700;
        white-space: nowrap;
      }

      .dropdown-wrapper {
          margin: 0 79px 0 12px;
          display: flex;
          flex-grow: 1;
          flex-basis: 0;
  
          kdx-dropdown-list {
              width: 100%;
              position: relative;
              
              button {
                svg {
                  @include svg-format(14px, 16px, $primary);
                }
              }
      
              .dropdown-text {
                  text-transform: none;
                  color: $gray-dark;
              }
      
              .form-control {
                  background: transparent;
                  border-bottom: 1px solid $gray-dark;
                  box-shadow: none;
                  color: $gray-dark;
                  text-transform: none;
                  font-weight: 400;
                  @include text-size(16);
                  @include line-height(20);

                  .svg-icon {
                    svg {
                      @include svg-format(14px, 16px, $secondary);
                    }
                  }
              }
          }
      }
      .btn.btn-primary {
        padding: 14px 16px;
        max-width: 53px;
        max-height: 46px;
        position: absolute;
        top: 9px;
        right: 22px;
      }
  }
}

@include media-breakpoint-down(lg) {
  kdx-pageselector {
    max-width: 100%;
  }
}

@include media-breakpoint-down(md) {
kdx-pageselector {
  
  .kdx-pageselector {
    position: relative;

    &__inner {
      flex-wrap: wrap;
      justify-content: flex-start;
      padding: 9px 9px 13px 22px;

      .dropdown-wrapper {
        min-width: 75%;
        margin: 0 15px 0 0;
        flex-grow: 0;
        flex-basis: 0;

        .kdx-dropdown-list {
          .form-control {
            padding: 0;
            min-height: 21.5px;
            @include text-size(14);
            line-height: auto;
          }
        }

      }

      .form-control { 
        padding: 0;
      }

      button {
        padding: 10px;

        &.btn.btn-primary {
          position: absolute;
          right: 9px;
          top: 9px;
        }
      }
      
    }
    .kdx-pageselector__title {
      @include text-size(14);
      @include line-height(22);
      width: 100%;
      text-align: left;
    }
  }
}
}
